import React from 'react';
import {
    StyleSheet,
    View,
    TouchableOpacity,
    ScrollView,
    TouchableWithoutFeedback,
    ActivityIndicator
  } from 'react-native'
import stylesheet from './Style'
import MyText from './MyText';
import MyDatePicker from './MyDatePicker';
import MyTextInput from './MyTextInput';
import MyPicker from './MyPicker';
import { MaterialIcons, Entypo, Feather } from '@expo/vector-icons'; 
import * as SecureStore from 'expo-secure-store';
import axios from 'axios';

export default function RegisterShipUser(props) {
    const css = stylesheet();
    
    const [countries, setCountries] = React.useState(null);
    const [shipTypes, setShipTypes] = React.useState(null);
    const [wasteMetrics, setWasteMetrics] = React.useState(null);

    const [countryFlagCords, setCountryFlagCords] = React.useState(0);

    const [shipEditable, setShipEditable] = React.useState(true);

    const [imo, setImo] = React.useState({
        value: '',
        hasError: false,
        valid: false
    });
    const [shipName, setShipName] = React.useState({
        value: '',
        hasError: false
    });
    const [shipType, setShipType] = React.useState({
        value: '',
        hasError: false
    });
    const [countryFlag, setCountryFlag] = React.useState({
        value: '',
        hasError: false
    });
    const [grossTonnage, setGrossTonnage] = React.useState({
        value: '',
        hasError: false
    });
    const [grossTonnageType, setGrossTonnageType] = React.useState({
        value: 'Ton',
        hasError: false
    });
    const [registryOffice, setRegistryOffice] = React.useState({
        value: '',
        hasError: false
    });
    const [grt, setGrt] = React.useState({
        value: '',
        hasError: false
    });
    const [grtType, setGrtType] = React.useState({
        value: 'Ton',
        hasError: false
    });
    const [dwt, setDwt] = React.useState({
        value: '',
        hasError: false
    });
    const [dwtType, setDwtType] = React.useState({
        value: 'Ton',
        hasError: false
    });

    //Contact person
    const [contactPersonFName, setContactPersonFName] = React.useState({
        value: '',
        hasError: false
    });
    const [contactPersonLName, setContactPersonLName] = React.useState({
        value: '',
        hasError: false
    });
    const [contactPersonProfession, setContactPersonProfession] = React.useState({
        value: '',
        hasError: false
    });
    const [contactPersonEmail, setContactPersonEmail] = React.useState({
        value: '',
        hasError: false,
        valid: false
    });
    const [contactPersonPhone, setContactPersonPhone] = React.useState({
        value: '',
        hasError: false,
        valid: false
    });

    const GetShipByIMO = () => {
        setShipEditable(true);
        axios.get('/api/getShip.php', {
            params: {
                imo: imo.value
            }
        })
        .then((res) => {
            if(res.data.length > 0)
                SetShip(res.data[0].data);
        })
      }
      const GetShipByName = () => {
          setShipEditable(true);
        axios.get('/api/getShip.php', {
            params: {
                shipName: shipName.value.toLowerCase()
            }
        })
        .then((res) => {
            if(res.data.length > 0)
                SetShip(res.data[0].data);
        })
      }
      const SetShip = (data) => {
        setShipEditable(false);
        setImo({
            hasError: false,
            value: (data.imo??"").toString(),
            valid: true
        })
        setShipName({
            hasError: false,
            value: (data.shipName??"").toString()
        })
        setCountryFlag({
            hasError: false,
            value: (data.countryFlag??"").toString()
        })
        setShipName({
            hasError: false,
            value: (data.shipName??"").toString()
        })
        setGrossTonnage({
            hasError: false,
            value: (data.grossTonnage??"").toString()
        })
        setGrossTonnageType({
            hasError: false,
            value: (data.grossTonnageType??"").toString()
        })
        setGrt({
            hasError: false,
            value: (data.grt??"").toString()
        })
        setGrtType({
            hasError: false,
            value: (data.grtType??"").toString()
        })
        if(!data.grt){
            setGrt({
                hasError: false,
                value: (data.grossTonnage??"").toString()
            })
            setGrtType({
                hasError: false,
                value: (data.grossTonnageType??"").toString()
            })
        }
        setDwt({
            hasError: false,
            value: (data.dwt??"").toString()
        })
        setDwtType({
            hasError: false,
            value: (data.dwtType??"").toString()
        })
        setShipType({
            hasError: false,
            value: (data.shipType??"").toString()
        })
        setRegistryOffice({
            hasError: false,
            value: (data.registryOffice??"").toString()
        })
        setContactPersonFName({
            hasError: false,
            value: (data.contactPersonFName??"").toString()
        })
        setContactPersonLName({
            hasError: false,
            value: (data.contactPersonLName??"").toString()
        })
        setContactPersonProfession({
            hasError: false,
            value: (data.contactPersonProfession??"").toString()
        })
        setContactPersonEmail({
            hasError: false,
            value: (data.contactPersonEmail??"").toString()
        })
        setContactPersonPhone({
            hasError: false,
            value: (data.contactPersonPhone??"").toString()
        })
      }

    React.useEffect(() => {
        // calculate hasError and send to parent
        setImo(val => ({...val, hasError: (!val.value || !val.valid)}));
        setShipName(val => ({...val, hasError: !val.value}));
        setShipType(val => ({...val, hasError: !val.value}));
        setGrossTonnage(val => ({...val, hasError: !val.value}));
        setGrossTonnageType(val => ({...val, hasError: !val.value}));
        setGrt(val => ({...val, hasError: !val.value}));
        setGrtType(val => ({...val, hasError: !val.value}));
        setDwt(val => ({...val, hasError: !val.value}));
        setDwtType(val => ({...val, hasError: !val.value}));
        setCountryFlag(val => ({...val, hasError: !val.value}));
        setRegistryOffice(val => ({...val, hasError: !val.value}));

        setContactPersonFName(val => ({...val, hasError: !val.value}));
        setContactPersonLName(val => ({...val, hasError: !val.value}));
        setContactPersonEmail(val => ({...val, hasError: (!val.value || !val.valid)}));
        setContactPersonPhone(val => ({...val, hasError: (!val.value || !val.valid)}));
    },[imo.value, shipName.value, shipType.value, grossTonnage.value, grossTonnageType.value, grt.value, grtType.value, dwt.value, dwtType.value, countryFlag.value, registryOffice.value,
        contactPersonFName.value, contactPersonLName.value, contactPersonProfession.value, contactPersonEmail.value, contactPersonPhone.value])

    React.useEffect(() => {
        const data = {
            imo,
            shipName,
            shipType,
            grossTonnage,
            grossTonnageType,
            grt,
            grtType,
            dwt,
            dwtType,
            countryFlag,
            registryOffice,
            contactPersonFName,
            contactPersonLName,
            contactPersonProfession,
            contactPersonEmail,
            contactPersonPhone
        }
        props.setRegisterShipUser(data);
    },[imo.hasError, shipName.hasError, shipType.hasError, grossTonnage.hasError, grossTonnageType.hasError, grt.hasError, grtType.hasError, dwt.hasError, dwtType.hasError, countryFlag.hasError, registryOffice.hasError,
        contactPersonFName.hasError, contactPersonLName.hasError, contactPersonProfession.hasError, contactPersonEmail.hasError, contactPersonPhone.hasError,
        imo.value, shipName.value, shipType.value, grossTonnage.value, grossTonnageType.value, grt.value, grtType.value, dwt.value, dwtType.value, countryFlag.value, registryOffice.value,
        contactPersonFName.value, contactPersonLName.value, contactPersonProfession.value, contactPersonEmail.value, contactPersonPhone.value])

            
    // React.useEffect(() => {
    //     setImo(val => ({...val, hasError: (!val.value || !val.valid)}));
    //     setContactPersonEmail(val => ({...val, hasError: (!val.value || !val.valid)}));
    //     setContactPersonPhone(val => ({...val, hasError: (!val.value || !val.valid)}));
    // },[imo.valid, contactPersonEmail.valid, contactPersonPhone.valid])

    React.useEffect(() => {
        axios.get('/api/getCountries.php')
        .then((res) => {
            let tempCountries = [];
            res.data.forEach(cou => {
                tempCountries.push({key: cou.key, value: cou.value});
            })
            setCountries(tempCountries);
        })
        axios.get('/api/getShipType.php')
        .then((res) => {
            let tempShipTypes = [];
            res.data.forEach(row => {
                tempShipTypes.push(row);
            })
            setShipTypes(tempShipTypes);
        })
        axios.get('/api/getWasteMetric.php')
        .then((res) => {
            let tempWasteMetrics = [];
            res.data.forEach(row => {
                tempWasteMetrics.push(row);
            })
            setWasteMetrics(tempWasteMetrics);
        })
    },[]);

    React.useEffect(() => {
        if(props.initialShip){
            const data = props.initialShip;
            setImo(prev => ({...prev, value: data.imo.toString()}));
            setShipName(prev => ({...prev, value: data.shipName}));
            setShipType(prev => ({...prev, value: data.shipType}));
            setGrossTonnage(prev => ({...prev, value: data.grossTonnage}));
            setGrossTonnageType(prev => ({...prev, value: data.grossTonnageType}));
            setGrt(prev => ({...prev, value: data.grt}));
            setGrtType(prev => ({...prev, value: data.grtType}));
            setDwt(prev => ({...prev, value: data.dwt}));
            setDwtType(prev => ({...prev, value: data.dwtType}));
            setCountryFlag(prev => ({...prev, value: data.countryFlag}));
            setRegistryOffice(prev => ({...prev, value: data.registryOffice}));
            setContactPersonFName(prev => ({...prev, value: data.contactPersonFName}));
            setContactPersonLName(prev => ({...prev, value: data.contactPersonLName}));
            setContactPersonProfession(prev => ({...prev, value: data.contactPersonProfession}));
            setContactPersonEmail(prev => ({...prev, value: data.contactPersonEmail}));
            setContactPersonPhone(prev => ({...prev, value: data.contactPersonPhone}));
            // setCompanyRegNum(prev => ({...prev, value: data.companyRegNumber.toString()}));
            // setCompanyName(prev => ({...prev, value: data.companyName}));
            // setAddress(prev => ({...prev, value: data.address}));
            // setArea(prev => ({...prev, value: data.area}));
            // setPostalCode(prev => ({...prev, value: data.postalCode.toString()}));
            // setCountryFlag(prev => ({...prev, value: data.country}));
            // setVatNumber(prev => ({...prev, value: data.vat}));
            // setVatType(prev => ({...prev, value: data.vatType}));
            // setTaxOffice(prev => ({...prev, value: data.taxOffice}));
            // setVatExceptionReason(prev => ({...prev, value: data.vatExceptionReason}));
            // setEmail(prev => ({...prev, value: data.email}));
            // setPhone(prev => ({...prev, value: data.phone}));
            // setWebsite(prev => ({...prev, value: data.website}));
            // setContactPersonFName(prev => ({...prev, value: data.contactFirstName}));
            // setContactPersonLName(prev => ({...prev, value: data.contactLastName}));
            // setContactPersonProfession(prev => ({...prev, value: data.contactPosition}));
            // setContactPersonEmail(prev => ({...prev, value: data.contactEmail}));
            // setContactPersonPhone(prev => ({...prev, value: data.contactPhone}));
        }
    },[props.initialShip])

    return (
      <>
        <View style={[{zIndex: 10}, css.form]} >
            <MyText style={[css.formTitle, css.bold]}>
                Ship Information
            </MyText>
            <View
            style={{
                borderBottomColor: '#f3f1f8',
                borderBottomWidth: 2,
            }}
            />
            <View style={css.formContainer}>
            <View style={css.formRow}>
                <MyText style={css.formRowLabel}>
                IMO Number
                </MyText>
                <MyTextInput
                    style={css.formRowInput}
                    onChangeText={(e) => {
                            setImo(prev => ({
                                ...prev,
                                value: e
                            }))
                        }
                    }
                    value={imo.value}
                    hasError={imo.hasError && props.submit}
                    onChangeValidation={(e) => {
                            setImo(prev => ({
                                ...prev,
                                valid: e
                            }))
                        }
                    }
                    onBlur={(e) => {
                        GetShipByIMO();
                    }}
                    inputMode='decimal'
                    keyboardType='phone-pad'
                    validation='imo'
                    isInfo={props.isInfo}
                />
            </View>
            <View style={css.formRow}>
                <MyText style={css.formRowLabel}>
                    Ship Name
                </MyText>
                <MyTextInput
                    style={css.formRowInput}
                    onChangeText={(e) => {
                            setShipName(prev => ({
                                ...prev,
                                value: e
                            }))
                        }
                    }
                    onBlur={(e) => {
                        GetShipByName();
                    }}
                    value={shipName.value}
                    hasError={shipName.hasError && props.submit}
                    isInfo={props.isInfo}
                />
            </View>
            <View style={css.formRow}>
                <MyText style={css.formRowLabel}>
                    Ship Type
                </MyText>
                <MyPicker
                    style={css.formRowInput}
                    items={shipTypes}
                    onValueChange={(item, itemIndex) => setShipType(prev => ({
                        ...prev,
                        value: item.value
                    }))}
                    value={shipType.value}
                    hasError={shipType.hasError && props.submit}
                    editable={shipEditable}
                    isInfo={props.isInfo}
                />
            </View>
            <View style={[{zIndex: 9}, css.formRow]}>
                <MyText style={css.formRowLabel}>
                Gross Tonnage
                </MyText>
                <View style={[{flex: 1}, css.doubleInput]}>
                <MyTextInput
                    inputMode='decimal'
                    keyboardType='phone-pad'
                    style={[{flexGrow: 1, flexShrink: 1, marginRight: 5}, css.formRowInput]}
                    onChangeText={(e) => setGrossTonnage(prev => ({
                        ...prev,
                        value: e
                    }))}
                    value={grossTonnage.value}
                    hasError={grossTonnage.hasError && props.submit}
                    editable={shipEditable}
                    isInfo={props.isInfo}
                />
                <View style={css.secondInput}>
                    <MyPicker
                        style={css.formRowInput}
                        width={65}
                        items={wasteMetrics}
                        onValueChange={(item, itemIndex) => setGrossTonnageType(prev => ({
                            ...prev,
                            value: item.value
                        }))}
                        value={grossTonnageType.value}
                        hasError={grossTonnageType.hasError && props.submit}
                        editable={shipEditable}
                        isInfo={props.isInfo}
                    >
                    </MyPicker>
                </View>
                </View>
            </View>
            <View style={[{zIndex: 8}, css.formRow]}>
                <MyText style={css.formRowLabel}>
                GRT
                </MyText>
                <View style={[{flex: 1}, css.doubleInput]}>
                <MyTextInput
                    inputMode='decimal'
                    keyboardType='phone-pad'
                    style={[{flexGrow: 1, flexShrink: 1, marginRight: 5}, css.formRowInput]}
                    onChangeText={(e) => setGrt(prev => ({
                        ...prev,
                        value: e
                    }))}
                    value={grt.value}
                    hasError={grt.hasError && props.submit}
                    editable={shipEditable}
                    isInfo={props.isInfo}
                />
                <View style={css.secondInput}>
                    <MyPicker
                        style={css.formRowInput}
                        width={65}
                        items={wasteMetrics}
                        onValueChange={(item, itemIndex) => setGrtType(prev => ({
                            ...prev,
                            value: item.value
                        }))}
                        value={grtType.value}
                        editable={shipEditable}
                        isInfo={props.isInfo}
                    >
                    </MyPicker>
                </View>
                </View>
            </View>
            <View style={[{zIndex: 7}, css.formRow]}>
                <MyText style={css.formRowLabel}>
                DWT
                </MyText>
                <View style={[{flex: 1}, css.doubleInput]}>
                <MyTextInput
                    inputMode='decimal'
                    keyboardType='phone-pad'
                    style={[{flexGrow: 1, flexShrink: 1, marginRight: 5}, css.formRowInput]}
                    onChangeText={(e) => setDwt(prev => ({
                        ...prev,
                        value: e
                    }))}
                    value={dwt.value}
                    hasError={dwt.hasError && props.submit}
                    editable={shipEditable}
                    isInfo={props.isInfo}
                />
                <View style={css.secondInput}>
                    <MyPicker
                        style={css.formRowInput}
                        width={65}
                        items={wasteMetrics}
                        onValueChange={(item, itemIndex) => setDwtType(prev => ({
                            ...prev,
                            value: item.value
                        }))}
                        value={dwtType.value}
                        editable={shipEditable}
                        isInfo={props.isInfo}
                    >
                    </MyPicker>
                </View>
                </View>
            </View>
            <View style={[{zIndex: 6}, css.formRow]} onLayout={(event) => {setCountryFlagCords(event.nativeEvent.layout.y + 450)}}>
                <MyText style={css.formRowLabel}>
                Country Flag
                </MyText>
                <MyPicker
                    style={css.formRowInput}
                    items={countries}
                    onValueChange={(item, itemIndex) => setCountryFlag(prev => ({
                        ...prev,
                        value: item.value
                    }))}
                    showSearch={true}
                    value={countryFlag.value}
                    hasError={countryFlag.hasError && props.submit}
                    // willShow={() => {
                    //         props.scrollRef.current.scrollTo({
                    //             x: 0,
                    //             y: countryFlagCords,
                    //             animated: false,
                    //         })
                    //     }
                    // }
                    editable={shipEditable}
                    isInfo={props.isInfo}
                >
                </MyPicker>
            </View>
            <View style={css.formRow}>
                <MyText style={css.formRowLabel}>
                Registry Office
                </MyText>
                <MyTextInput
                style={css.formRowInput}
                onChangeText={(e) => setRegistryOffice(prev => ({
                    ...prev,
                    value: e
                }))}
                value={registryOffice.value}
                hasError={registryOffice.hasError && props.submit}
                editable={shipEditable}
                isInfo={props.isInfo}
                />
            </View>
            <View style={[css.formRow, {flexBasis: '100%', marginTop: 20, marginBottom: 15}]}>
                <MyText style={[css.m, styles.contactPersonTitle]}>
                    Contact Person
                </MyText>
            </View>
            <View style={[{zIndex: 10}, css.formRow]}>
                <MyText style={css.formRowLabel}>
                    First Name
                </MyText>
                <MyTextInput
                    style={css.formRowInput}
                    onChangeText={(e) => setContactPersonFName(prev => ({
                        ...prev,
                        value: e
                    }))}
                    value={contactPersonFName.value}
                    hasError={contactPersonFName.hasError && props.submit}
                    isInfo={props.isInfo}
                />
            </View>
            <View style={[{zIndex: 9}, css.formRow]}>
                <MyText style={css.formRowLabel}>
                    Last Name
                </MyText>
                <MyTextInput
                    style={css.formRowInput}
                    onChangeText={(e) => setContactPersonLName(prev => ({
                        ...prev,
                        value: e
                    }))}
                    value={contactPersonLName.value}
                    hasError={contactPersonLName.hasError && props.submit}
                    isInfo={props.isInfo}
                />
            </View>
            <View style={[{zIndex: 9}, css.formRow]}>
                <MyText style={css.formRowLabel}>
                    Profession
                </MyText>
                <MyTextInput
                    style={css.formRowInput}
                    onChangeText={(e) => setContactPersonProfession(prev => ({
                        ...prev,
                        value: e
                    }))}
                    value={contactPersonProfession.value}
                    hasError={contactPersonProfession.hasError && props.submit}
                    isInfo={props.isInfo}
                />
            </View>
            <View style={[{zIndex: 9}, css.formRow]}>
                <MyText style={css.formRowLabel}>
                    Email
                </MyText>
                <MyTextInput
                    style={css.formRowInput}
                    onChangeText={(e) => setContactPersonEmail(prev => ({
                        ...prev,
                        value: e
                    }))}
                    onChangeValidation={(e) => {
                        console.log(e);
                        setContactPersonEmail(prev => ({
                                ...prev,
                                valid: e
                            }))
                        }
                    }
                    value={contactPersonEmail.value}
                    hasError={contactPersonEmail.hasError && props.submit}
                    inputMode='email'
                    keyboardType='email-address'
                    validation='email'
                    isInfo={props.isInfo}
                    autoCapitalize='none'
                    autoCorrect={false}
                />
            </View>
            <View style={[{zIndex: 9}, css.formRow]}>
                <MyText style={css.formRowLabel}>
                    Phone
                </MyText>
                <MyTextInput
                    inputMode='decimal'
                    keyboardType='phone-pad'
                    style={css.formRowInput}
                    onChangeText={(e) => setContactPersonPhone(prev => ({
                        ...prev,
                        value: e
                    }))}
                    onChangeValidation={(e) => {
                        setContactPersonPhone(prev => ({
                                ...prev,
                                valid: e
                            }))
                        }
                    }
                    value={contactPersonPhone.value}
                    hasError={contactPersonPhone.hasError && props.submit}
                    validation='phone'
                    isInfo={props.isInfo}
                />
            </View>
        </View>
    </View>
    </>
);
}

const styles = StyleSheet.create({
    contactPersonTitle: {
        color: '#461b6f',
        // paddingHorizontal: 15,
    },
});
